import * as React from 'react'

import { Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onDelete: () => void
}

const DeleteModal = ({ onClose, onDelete }: Props) => {
  return (
    <Modal
      illustration="delete"
      title={i18n.t('payroll_bundle.supplements.delete_modal.title')}
      description={
        <Text.Normal>{i18n.t('payroll_bundle.supplements.delete_modal.description')}</Text.Normal>
      }
      onClose={onClose}
      onSubmit={onDelete}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('common.delete')}</Button>
        </>
      }
    />
  )
}

export default observer(DeleteModal)
